import loadable from '../../utilities/loadable'

export const NotificationsRoot = loadable(() => import('./NotificationsRoot'))
